module.exports = __webpack_public_path__ + "img/blackTrash.55dd0437.svg";